import { Link } from "wouter";

interface ExtraLink {
  label: string;
  href: string;
  external?: boolean;
}

interface LegalFooterProps {
  colorScheme?: "light" | "dark";
  copyright?: string;
  extraLinks?: ExtraLink[];
}

const YEAR = new Date().getFullYear();

export function LegalFooter({
  colorScheme = "light",
  copyright,
  extraLinks,
}: LegalFooterProps) {
  const isDark = colorScheme === "dark";
  const baseClass = isDark ? "text-white/70 hover:text-white/90" : "text-slate-600 hover:text-slate-800";

  const coreLinks: ExtraLink[] = [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Use", href: "/terms" },
    { label: "Accessibility", href: "/accessibility" },
  ];

  const allLinks: ExtraLink[] = extraLinks ? [...coreLinks, ...extraLinks] : coreLinks;

  return (
    <footer
      className={`py-3 px-6 border-t text-xs flex flex-wrap gap-x-5 gap-y-1 items-center justify-between ${
        isDark ? "border-white/10" : "border-slate-200 bg-white"
      }`}
    >
      <span className={isDark ? "text-white/60" : "text-slate-600"}>
        {copyright ?? `© ${YEAR} Medantix Health Ltd`}
      </span>
      <nav aria-label="Legal links">
        <div className="flex flex-wrap gap-x-4 gap-y-1">
          {allLinks.map((link) =>
            link.external ? (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`underline ${baseClass}`}
              >
                {link.label}
              </a>
            ) : (
              <Link key={link.href} href={link.href} className={`underline ${baseClass}`}>
                {link.label}
              </Link>
            )
          )}
          <a href="mailto:privacy@medantixhealth.co.uk" className={`underline ${baseClass}`}>
            Contact
          </a>
        </div>
      </nav>
    </footer>
  );
}
